import React, { useEffect, useState } from 'react'
import voucherPaymentItemServices from '../voucherPaymentItemServices';
import { CircularProgress } from '@mui/material';
import moment from 'moment';
import { Link } from 'react-router-dom';
import VoucherPaymentItemForm from './VoucherPaymentItemForm';
import { useAlert } from '../../../../../../context/AlertContext';
import { Pending } from '@mui/icons-material';

function VoucherPaymentItemList({voucherDetails,pendingAllocation,setPendingAllocation}) {

    const [itemList,setItemList] = useState([]);
    const [loading,setLoadingStatus] = useState(false);
    const {AppAlert} = useAlert();

    const calculatePendingAllocation = () =>{
        console.log(JSON.stringify(itemList));
        let _totalAllocation = itemList.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
        let _pendingAllocation = voucherDetails.grandTotal - _totalAllocation;
        setPendingAllocation(_pendingAllocation);
    }

    const getItemList = () =>{
        setLoadingStatus(true);
        voucherPaymentItemServices.getByPaymentVoucherId(voucherDetails.id).then(res=>{
            setItemList(res.data);
        }).catch(error=>{
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    useEffect(()=>{
        getItemList();
    },[voucherDetails])


    const handleDeleteLine = async (allocationId) => {
        if (!window.confirm("Are you sure you want to remove this line allocation?")) return;
        setLoadingStatus(true);
        voucherPaymentItemServices.remove(allocationId).then(res=>{
            AppAlert(res.msg);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setLoadingStatus(false);
            getItemList();
        })
    };


    useEffect(()=>{
        calculatePendingAllocation();
    },[itemList])

    return (
        <>
            {loading ?
                <div className='text-center'>
                    <CircularProgress />
                </div>
                :
                <table className='mt-2 table table-bordered'>
                    <thead>
                        <tr>
                            <th>Voucher No</th>
                            <th>Grand Total</th>
                            <th>Allocated</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemList.map(item=>
                            <tr key={item.allocationId}>
                                <td><Link to={"/voucher/sale-purchase/details/"+item.id}>{item.voucherNo}</Link> </td>
                                <td>{item.grandTotal}</td>
                                <td>{item.amount}</td>
                                <td>
                                    {voucherDetails.status == 1 && (
                                        <td className="text-center">
                                            <button 
                                                type="button" 
                                                className="btn btn-link link-danger p-0 border-0"
                                                onClick={() => handleDeleteLine(item.allocationId)}
                                            >
                                                <i className="bi bi-trash-fill">Delete</i>
                                            </button>
                                        </td>
                                    )}
                                </td>
                            </tr>    
                        )}
                    </tbody>
                    {voucherDetails.status === 1 && pendingAllocation > 0 && 
                    <tbody>
                        <tr>
                            <td colSpan={4}><VoucherPaymentItemForm voucherDetails={voucherDetails} pendingAllocation={pendingAllocation} callBack={getItemList} /> </td>
                        </tr>
                    </tbody>
                    }
                </table>
            }
        </>
    )
}

export default VoucherPaymentItemList